<template>
  <div id="Close">
    <div class="background-dim" @click.self="hideCloseModal">
      <div class="window">
        <div class="alert-text">
          결제를 중단하시겠습니까?
        </div>
        <button class="stop-payemnt" :style="styleObject" @click="closePage">확인</button>
      </div>
    </div>
  </div>
</template>

<script>
import vuex from 'vuex'

export default {
  computed: {
    ...vuex.mapGetters({
      'getColor': 'style/getColor',
      'GET_MODAL': 'display/GET_MODAL',
      'GET_PAYMENT_INFORMATION': 'GET_PAYMENT_INFORMATION',
      'GET_REDIRECT': 'GET_REDIRECT'
    }),
    styleObject: function() {
      return {
        '--color': this.getColor.primaryColor,
        '--color-active': this.getColor.primaryColorDark
      }
    }
  },
  methods: {
    ...vuex.mapActions({
      'TOGGLE_CLOSE_WINDOW': 'display/TOGGLE_CLOSE_WINDOW'
    }),
    closePage() {
      this.TOGGLE_CLOSE_WINDOW();
      console.log(this.GET_REDIRECT, this.GET_PAYMENT_INFORMATION)
      let url = this.GET_PAYMENT_INFORMATION.payload.error_url;
      console.log(url)
      location.replace(url)
      // location.href = url;
      // window.close();
      // self.close();
      // open(document.location, '_self').close();
    },
    hideCloseModal() {
      this.TOGGLE_CLOSE_WINDOW();
    }
  }
}
</script>

<style lang="scss">
#Close {
  .background-dim {
    display: flex;
    justify-content: center;
    align-items: center;

    position: fixed;
    z-index: 1000;

    top: 0; right: 0; bottom: 0; left: 0;

    background-color: $color-black-80;

    .window {
      width: 300px;
      padding: 30px 30px 20px;

      border-radius: 30px;
      background-color: white;

      .alert-text {
        font-size: 17px;
        color: #424242;

        text-align: center;
        line-height: 1.65;
      }
      .stop-payemnt {
        width: 240px;
        height: 50px;
        margin-top: 30px;

        border: solid 1px var(--color);
        border-radius: 25px;
        font-size: 17px;

        background-color: white;
        color: var(--color);

        line-height: 1.65;

        &:active {
          border-color: var(--color-active);
          color: var(--color-active);
        }
      }
    }
  }
}
</style>